// components/MenuList.js
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useUser } from '../../context/UserContext'
import './RestaurantStyle.css'
import { ArrowBack } from '@mui/icons-material'

export const MenuList = ({ selectedRestaurant, goBack }) => {
  const { userInfo, setUserInfo } = useUser()
  const [menuData, setMenuData] = useState(null)
  const [apiData, setApiData] = useState(null)
  const [selectedItems, setSelectedItems] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isPurchasing, setIsPurchasing] = useState(false)
  const [purchaseError, setPurchaseError] = useState(null)
  const [purchaseSuccess, setPurchaseSuccess] = useState(null)

  const clearOrder = () => {
    setSelectedItems([])
    setPurchaseError(null)
  }

  const handleItemClick = (product, attribute) => {
    const selectedItem = {
      name: `${product.slug.replaceAll('-', ' ')} ${attribute.name[0]?.text}`,
      price: attribute.loyalty_points_price,
      voucher_product_attribute: attribute.id,
      voucher_product_id: product.id
    }
    setSelectedItems([...selectedItems, selectedItem])
  }

  const calculateTotal = items => items.reduce((total, item) => total + item.price, 0)

  const confirmPurchase = async () => {
    // Сброс ошибки перед началом нового запроса
    setPurchaseError(null)

    const localData = userInfo?.locals?.find(local => local.local_id === String(selectedRestaurant?.id))

    if (!localData) {
      alert('Brak danych lojalności dla tego lokalu.')
      return
    }

    const token = localStorage.getItem('token')
    if (!token) {
      alert('Brak tokena autoryzacyjnego.')
      return
    }

    const payload = {
      local_id: localData.local_id,
      voucher_products: selectedItems.map(item => ({
        voucher_product_attribute: item.voucher_product_attribute,
        voucher_product_id: item.voucher_product_id
      }))
    }

    setIsPurchasing(true)
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/loyalty/buy-products', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })

      if (response.data && response.data.success === false) {
        setPurchaseError(response.data.errors.join(', '))
      } else {
        setPurchaseError(null)
        setPurchaseSuccess(
          'Sukces twoje danie jest gotowe do odbioru w restauracji, podaj numer telefonu Kelnera i odbierz!'
        )
        setSelectedItems([])

        setTimeout(() => {
          setPurchaseSuccess(null)
          setPurchaseError(null)
          setIsModalOpen(false)
        }, 3000)
      }
    } catch (error) {
      console.error('Error during purchase:', error)
      setPurchaseError('Wystąpił błąd przy zakupie. Spróbuj ponownie.')
    } finally {
      setIsPurchasing(false)
    }
  }

  const Modal = ({ onClose }) => {
    const removeItem = index => {
      const updatedItems = selectedItems.filter((_, i) => i !== index)
      setSelectedItems(updatedItems)
    }

    return (
      <>
        <div className='overlay' onClick={onClose}></div>
        <div className='modal-container slide-up'>
          <div className='modal-header'>
            <h2>Twoje zamówienie</h2>
            <button onClick={onClose} className='close-button'>
              &#10006;
            </button>
          </div>

          {purchaseError && (
            <div
              className='error-message'
              style={{
                color: '#FF000042',
                fontWeight: 'bold',
                fontFamily: 'Poppins'
              }}
            >
              {purchaseError}
            </div>
          )}

          {purchaseSuccess && (
            <div
              className='success-message'
              style={{
                color: '#4CAF50',
                fontWeight: 'bold',
                fontFamily: 'Poppins'
              }}
            >
              {purchaseSuccess}
            </div>
          )}

          {selectedItems.map((item, index) => (
            <div key={index} className='product-in-order'>
              <p>
                <button onClick={() => removeItem(index)} className='transparent-button'>
                  Usuń
                </button>
                {item.name} <span className='price-style'>Wartość: {item.price}pkt</span>
              </p>
            </div>
          ))}
          <p className='summary'>Podsumowanie: {calculateTotal(selectedItems)}pkt</p>
          <button onClick={confirmPurchase} className='confirm-button' disabled={isPurchasing}>
            {isPurchasing ? 'Przetwarzanie...' : 'Potwierdź zakup za punkty'}
          </button>
        </div>
      </>
    )
  }

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [isModalOpen])

  useEffect(() => {
    if (selectedRestaurant) {
      const fetchData = {
        test: true,
        slug: selectedRestaurant.slug,
        debug: true,
        source: 3,
        loyalty_program: true,
        restaurant: {}
      }

      axios
        .post(process.env.REACT_APP_API_URL + '/restaurant', fetchData)
        .then(response => {
          const apiData = response.data
          const categories = apiData.category
          const categoryNamesAndProductSlugs = categories.map(category => {
            const productsWithPoints = category.products
            return {
              categoryName: category.name[0]?.text,
              productSlugs: productsWithPoints.map(product => product.slug.toString())
            }
          })
          setApiData(apiData)
          setMenuData(categoryNamesAndProductSlugs)
        })
        .catch(error => {
          console.error('Error fetching data:', error)
        })
    }
  }, [selectedRestaurant])

  const localData = userInfo?.locals?.find(local => local.local_id === String(selectedRestaurant?.id))

  return (
    <div>
      {selectedRestaurant && (
        <div className='menu-list'>
          <div className='logo-badge-container'>
            <img src={selectedRestaurant.logo} alt={selectedRestaurant.name} className='restaurant-logo' />
            {userInfo && <div className='points-badge2'>Twoje punkty: {localData ? localData.points : 0} pkt</div>}
          </div>
          {selectedItems.length > 0 && (
            <button onClick={() => setIsModalOpen(true)} className='fixed-button'>
              Przejdż do podsumowania
            </button>
          )}
          {menuData && apiData && (
            <div>
              {apiData.category.map((category, index) => {
                const hasLoyaltyPointsProducts = category.products.some(product =>
                  product.attributes.some(
                    attribute =>
                      attribute.hasOwnProperty('loyalty_points_price') && attribute.loyalty_points_price !== 0
                  )
                )

                if (!hasLoyaltyPointsProducts) {
                  return null
                }

                return (
                  <div key={index} className='category'>
                    <strong className='categoryName'>{category.slug}</strong>
                    <div className='dania-list'>
                      {category.products.map(product => {
                        const hasLoyaltyPoints = product.attributes.some(
                          attribute =>
                            attribute.hasOwnProperty('loyalty_points_price') && attribute.loyalty_points_price !== 0
                        )

                        if (!hasLoyaltyPoints) {
                          return null
                        }

                        return (
                          <div key={product.id}>
                            {product.attributes.map(attribute => {
                              if (
                                attribute.hasOwnProperty('loyalty_points_price') &&
                                attribute.loyalty_points_price === 0
                              ) {
                                return null
                              }

                              return (
                                <div key={attribute.id} className='dania'>
                                  <p>
                                    {product.slug.replaceAll('-', ' ')} {attribute.name[0]?.text}
                                  </p>
                                  <p className='description'>{product.description[0]?.text}</p>
                                  {attribute.loyalty_points_price !== 0 && (
                                    <button
                                      className='buy-for-punkts'
                                      onClick={() => handleItemClick(product, attribute)}
                                    >
                                      Aktywuj za: {attribute.loyalty_points_price}pkt
                                    </button>
                                  )}
                                </div>
                              )
                            })}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
          {isModalOpen && (
            <Modal
              onClose={() => {
                setIsModalOpen(false)
                clearOrder()
              }}
            />
          )}
        </div>
      )}
    </div>
  )
}
